import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { fetchMultipleCommentPages } from 'bundles/discussions/actions/ThreadDetailsActions';
import { loadingStates } from 'bundles/discussions/constants';
import type { ForumPostReply } from 'bundles/discussions/lib/types';

type CommentPaginationContainerProps = {
  reply: ForumPostReply;
  answerId: string;
  commentId: string;
  commentLoadingState: string;
  comments: ForumPostReply[];
  commentPageRange: object;
  isQuestionLoaded: boolean;
  forumLink: string;
  forumType: string;
  includeDeleted: boolean;
  // @ts-expect-error ts-migrate(7051) FIXME: Parameter has a name but no type. Did you mean 'ar... Remove this comment to see the full error message
  children: (any) => JSX.Element | null;
  page: number;
  limit: number;
};

class CommentPaginationContainer extends React.Component<CommentPaginationContainerProps> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CommentPaginationContainer.contextTypes>;

  state = {
    loadingComments: false,
  };

  componentWillMount() {
    this.fetchComments(this.pagination);
  }

  fetchComments = ({ start = 1, end = 5 }) => {
    const { reply, answerId, commentId, forumType, includeDeleted } = this.props;

    // make sure that if we have a deep-linked comment, the comment is loaded.
    if (commentId && reply.topLevelForumAnswerId === answerId) {
      const { questionId } = reply;

      this.context.executeAction(fetchMultipleCommentPages, {
        questionId,
        answerId,
        userForumAnswerId: reply.id,
        startPage: start,
        endPage: end,
        forumType,
        includeDeleted,
      });
    }
  };

  get pagination() {
    const start = this.props.page > 1 ? this.props.page * this.props.limit : 0;
    const end = start + this.props.limit;
    return { start, end };
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    if (
      this.props.commentLoadingState === loadingStates.LOADING &&
      this.props.commentLoadingState !== nextProps.commentLoadingState
    ) {
      this.setState({ loadingComments: false });
    }

    if (nextProps.page !== this.props.page) {
      this.fetchComments(this.pagination);
    }
  }

  render() {
    // const subComments = this.props.comments.slice(start, end);
    return <>{this.props.children && this.props.children({ ...this.props, comments: this.props.comments })}</>;
  }
}

export default connectToStores<CommentPaginationContainerProps, any>(
  CommentPaginationContainer,
  ['ThreadDetailsStore', 'ApplicationStore', 'CourseMembershipStore'],
  ({ ThreadDetailsStore, ApplicationStore, CourseMembershipStore }, { reply }) => {
    return {
      comments: ThreadDetailsStore.getLoadedComments(reply.topLevelForumAnswerId),
      commentLoadingState: ThreadDetailsStore.commentLoadingState[reply.id] || loadingStates.LOADING,
      commentPageRange: ThreadDetailsStore.getCommentPageRange(reply.id),
      forumType: ThreadDetailsStore.forumType,
      includeDeleted: CourseMembershipStore.hasModerationRole() || ApplicationStore.isSuperuser(),
    };
  }
);
